import { render, staticRenderFns } from "./OrdemServicoForm.vue?vue&type=template&id=786843d6&scoped=true&"
import script from "./OrdemServicoForm.vue?vue&type=script&lang=js&"
export * from "./OrdemServicoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786843d6",
  null
  
)

export default component.exports